// This is strictly for handling birthday request recommendations for now, but could power a Birthdays view in the future
import Contact from '@repo/utils/models/Contact';
import { OrderedMap } from 'immutable';
import type { ID, ReduxAction } from '@repo/utils/types';
import { searchResponseToContactTuples } from './search/createSearchReducer';
import AppState from '../app-state';

export interface BirthdaysState {
  requestRecommendations: OrderedMap<ID, Contact>;
}

const initialBirthdaysState = {
  requestRecommendations: OrderedMap<ID, Contact>(),
};

export const selectBirthdayRequestRecommendations = (state: AppState): Contact[] =>
  state.data.birthdays.requestRecommendations.valueSeq().toArray().slice(0, 25);

export function birthdaysReducer(
  state: BirthdaysState = initialBirthdaysState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_BIRTHDAY_REQUEST_RECOMMENDATIONS_SUCCEEDED':
      return {
        ...state,
        requestRecommendations: OrderedMap(searchResponseToContactTuples(payload.response)),
      };

    case 'CREATE_BIRTHDAY_REQUEST_EMAILS_SUCCEEDED':
      return {
        ...state,
        requestRecommendations: state.requestRecommendations.filter(
          (contact) => !payload.contactIDs.includes(contact.id),
        ),
      };

    default:
      return state;
  }
}
